export const LANGUAGES_ES = [
    "Abjasio", "Afrikáans", "Albanés", "Alemán", "Amárico", "Árabe", "Armenio",
    "Asamés", "Azerí", "Bambara", "Bengalí", "Bielorruso", "Birmano", "Bosnio",
    "Búlgaro", "Camboyano (Jemer)", "Catalán", "Cebuano", "Checo", "Chichewa",
    "Chino cantonés", "Chino mandarín", "Cingalés", "Coreano", "Corso",
    "Criollo haitiano", "Croata", "Danés", "Dzongkha", "Eslovaco", "Esloveno",
    "Español", "Esperanto", "Estonio", "Euskera", "Ewé", "Filipino (Tagalo)",
    "Finés", "Francés", "Frisón", "Gaélico escocés", "Gallego", "Galés",
    "Georgiano", "Griego", "Guaraní", "Guyaratí", "Hausa", "Hawaiano", "Hebreo",
    "Hindi", "Hmong", "Húngaro", "Igbo", "Indonesio", "Inglés", "Irlandés",
    "Islandés", "Italiano", "Japonés", "Javanés", "Kazajo", "Kinyarwanda",
    "Kirguís", "Kurdo", "Lao", "Latín", "Letón", "Lingala", "Lituano",
    "Luxemburgués", "Macedonio", "Malayo", "Malayalam", "Malgache", "Maltés",
    "Maorí", "Maratí", "Mogol", "Neerlandés", "Nepalí", "Noruego",
    "Oriya (Odia)", "Oromo", "Panyabí", "Pastún", "Persa (Farsi)", "Polaco",
    "Portugués", "Quechua", "Rumano", "Ruso", "Samoano", "Serbio", "Sesoto",
    "Shona", "Sindhi", "Somalí", "Suajili", "Sueco", "Sundanés", "Tailandés",
    "Tamil", "Tayiko", "Telugu", "Tibetano", "Tigriña", "Tongano", "Tsonga",
    "Turco", "Turcomano", "Ucraniano", "Uigur", "Urdu", "Uzbeko", "Valenciano",
    "Vietnamita", "Xhosa", "Yidis", "Yoruba", "Zulú",
];

export const LANGUAGES_EN = [
    "Abkhaz", "Afrikaans", "Albanian", "Amharic", "Arabic", "Armenian",
    "Assamese", "Azerbaijani", "Bambara", "Basque", "Belarusian", "Bengali",
    "Bosnian", "Bulgarian", "Burmese", "Cambodian (Khmer)", "Catalan",
    "Cebuano", "Chichewa", "Chinese Cantonese", "Chinese Mandarin", "Corsican",
    "Croatian", "Czech", "Danish", "Dutch", "Dzongkha", "English", "Esperanto",
    "Estonian", "Ewe", "Filipino (Tagalog)", "Finnish", "French", "Frisian",
    "Galician", "Georgian", "German", "Greek", "Guarani", "Gujarati",
    "Haitian Creole", "Hausa", "Hawaiian", "Hebrew", "Hindi", "Hmong",
    "Hungarian", "Icelandic", "Igbo", "Indonesian", "Irish", "Italian",
    "Japanese", "Javanese", "Kazakh", "Kinyarwanda", "Kyrgyz", "Kurdish",
    "Lao", "Latin", "Latvian", "Lingala", "Lithuanian", "Luxembourgish",
    "Macedonian", "Malagasy", "Malay", "Malayalam", "Maltese", "Maori",
    "Marathi", "Mongolian", "Nepali", "Norwegian", "Odia (Oriya)", "Oromo",
    "Pashto", "Persian (Farsi)", "Polish", "Portuguese", "Punjabi", "Quechua",
    "Romanian", "Russian", "Samoan", "Scottish Gaelic", "Serbian", "Sesotho",
    "Shona", "Sindhi", "Sinhala", "Slovak", "Slovenian", "Somali", "Spanish",
    "Sundanese", "Swahili", "Swedish", "Tajik", "Tamil", "Telugu", "Thai",
    "Tibetan", "Tigrinya", "Tongan", "Tsonga", "Turkish", "Turkmen",
    "Ukrainian", "Urdu", "Uyghur", "Uzbek", "Valencian", "Vietnamese",
    "Welsh", "Xhosa", "Yiddish", "Yoruba", "Zulu",
];

export const translations = {
    es: {
        topbar: {
            email: "coordination@nmglobaltranslations.com",
            phone1: "+34 618 278 394",
            phone2: "+34 910 600 973",
        },
        nav: {
            languages: "Idiomas",
            services: "Servicios",
            quote: "Presupuesto",
            about: "Sobre nosotros",
            payment: "Formas de pago",
            contact: "Contacto",
        },
        hero: {
            title: "Rompe las barreras del idioma. Expande tu negocio globalmente.",
            subtitle: "Traducciones profesionales y juradas en más de 150 idiomas.",
            check1: "Traductores certificados",
            check2: "Entregas rápidas",
            check3: "Confidencialidad total",
            cta: "Solicitar presupuesto",
        },
        quote: {
            title: "Solicitar Presupuesto",
            subtitle: "Completa el formulario y te enviaremos un presupuesto personalizado entre 24-48 horas.",
            sourceLanguage: "Idioma origen",
            targetLanguage: "Idioma destino",
            serviceType: "Tipo de servicio",
            sworn: "Traducción jurada (con validez legal)",
            simple: "Traducción simple",
            interpretation: "Interpretación",
            deadline: "Fecha de entrega deseada",
            selectDate: "Seleccionar fecha",
            uploadFile: "Subir archivo",
            noFile: "Ningún archivo seleccionado",
            dragDrop: "Arrastra tu archivo aquí o haz clic para seleccionar",
            email: "Email de contacto",
            phone: "Teléfono de contacto",
            phonePlaceholder: "Ej: +34 600 000 000",
            message: "Mensaje",
            messagePlaceholder: "Describe brevemente tu proyecto de traducción...",
            submit: "Calcular presupuesto",
            submitting: "Enviando...",
            success: "Tu solicitud ha sido enviada correctamente. Te contactaremos en breve.",
            error: "Error al enviar. Inténtalo de nuevo.",
        },
        languages: {
            title: "150+ Idiomas",
            subtitle: "Traducciones profesionales en los idiomas más demandados del mundo.",
            search: "Buscar idioma...",
        },
        companies: {
            title: "Empresas que confían en nosotros",
            subtitle: "Organizaciones líderes confían en nuestros servicios de traducción profesional.",
        },
        services: {
            title: "Nuestros Servicios",
            subtitle: "Soluciones completas de traducción para todas tus necesidades.",
            simple: {
                title: "Traducción Simple",
                description: "Traducciones profesionales para todo tipo de documentos y contenidos.",
                items: [
                    "Traducciones jurídicas",
                    "Financieras y económicas",
                    "Empresariales",
                    "Páginas web y aplicaciones",
                    "Técnicas e informáticas",
                    "Turísticas y publicitarias",
                    "Médicas y farmacéuticas",
                    "Químicas y científicas",
                    "Culturales y literarias",
                    "Inmobiliarias y construcción",
                    "Alimentación y restauración",
                    "Telecomunicaciones",
                    "Sector educativo e institucional",
                    "Libros y periódicos",
                    "Moda y textiles",
                    "Subtitulación y doblaje",
                    "Traducciones generales",
                ],
            },
            sworn: {
                title: "Traducción Jurada",
                description: "Traducciones con validez legal, realizadas por traductores-intérpretes jurados oficiales.",
                includes: "Incluye:",
                items: [
                    "Documentos oficiales",
                    "Certificados de nacimiento",
                    "Certificados de matrimonio",
                    "Certificados de divorcio",
                    "Homologaciones",
                    "Documentos académicos",
                ],
                features: [
                    "Firma del traductor jurado",
                    "Sello oficial",
                    "Validez legal completa",
                ],
            },
            interpretation: {
                title: "Interpretación",
                description: "Servicios de interpretación profesional en tiempo real.",
                items: [
                    "Interpretación simultánea",
                    "Interpretación consecutiva",
                    "Interpretación de enlace",
                    "Interpretación de susurro (chuchotage)",
                    "Alquiler de cabinas y aparatos para intérpretes",
                    "Reuniones de negocios",
                    "Eventos internacionales",
                    "Conferencias y congresos",
                ],
            },
        },
        aboutCompany: {
            title: "Quiénes somos",
            text: "Somos una empresa destacada en servicios de traducción e interpretación, con más de 20 años de experiencia consolidada en el sector. A lo largo de nuestra trayectoria, hemos trabajado con una amplia variedad de especialidades, abarcando desde traducciones técnicas y jurídicas hasta servicios de interpretación en distintos ámbitos profesionales, incluyendo traducciones juradas con plena validez legal. Nuestro compromiso con la excelencia y la precisión lingüística nos ha permitido alcanzar una valoración media de satisfacción de 9,8 sobre 10 por parte de nuestros clientes, reflejo de la confianza que depositan en nuestro equipo y de la calidad constante de nuestros servicios. Contamos con profesionales altamente cualificados y especializados, capaces de adaptarse a las necesidades específicas de cada proyecto, garantizando siempre rigor, confidencialidad y cumplimiento de plazos. Elegirnos es apostar por una comunicación sin barreras, respaldada por la experiencia, la profesionalidad y una clara orientación al cliente.",
        },
        map: {
            title: "Alcance Global",
            subtitle: "Presencia en los 5 continentes. Traducciones sin fronteras.",
            regions: [
                "Europa",
                "Asia",
                "América",
                "África",
                "Oceanía",
            ],
        },
        testimonials: {
            title: "NM Global Translations en cifras",
            subtitle: "Miles de empresas y profesionales confían en nosotros.",
            metrics: {
                translations: "+20.000",
                translationsLabel: "Traducciones realizadas",
                clients: "+1.000",
                clientsLabel: "Clientes satisfechos",
                satisfaction: "98%",
                satisfactionLabel: "Índice de satisfacción",
                delivery: "24-48h",
                deliveryLabel: "Tiempo de presupuesto",
            },
        },
        about: {
            title: "Sobre Nosotros",
            subtitle: "Desde 2004, conectando culturas y negocios a través de traducciones de calidad.",
            description: "NM GLOBAL TRANSLATIONS es una agencia de traducción global con más de 1.500 traductores profesionales especializados en más de 150 idiomas.",
            values: [
                { title: "Calidad y especialización", desc: "Traductores nativos especializados en cada sector." },
                { title: "Agilidad y capacidad de respuesta", desc: "Entregas rápidas sin comprometer la calidad." },
                { title: "Adaptabilidad y soporte multilingüe", desc: "Nos adaptamos a las necesidades de cada cliente." },
                { title: "Confidencialidad y seguridad de datos", desc: "Protocolos estrictos de protección de información." },
                { title: "Cumplimiento de plazos", desc: "Entregamos siempre dentro del plazo acordado." },
                { title: "Atención personalizada", desc: "Un gestor dedicado para cada proyecto." },
                { title: "Mejora continua e innovación", desc: "Incorporamos las últimas tecnologías de traducción." },
            ],
        },
        payment: {
            title: "Formas de Pago",
            subtitle: "Aceptamos los siguientes métodos de pago para tu comodidad.",
            methods: [
                { title: "Transferencia bancaria", desc: "Realiza tu pago a través de transferencia bancaria directa." },
                { title: "PayPal", desc: "Paga de forma rápida y segura con tu cuenta de PayPal." },
            ],
        },
        footer: {
            tagline: "Conectando culturas y negocios a través de traducciones profesionales de alta calidad desde 2004",
            quickLinks: "Enlaces rápidos",
            contact: "Contacto",
            followUs: "Síguenos",
            rights: "Todos los derechos reservados.",
            copyright: "NM Global Translations",
            address: "Madrid, España",
        },
        whatsapp: {
            tooltip: "¿Necesitas ayuda? Escríbenos por WhatsApp y te respondemos al instante.",
            openChat: "Abrir chat",
            defaultMessage: "Hola, me gustaría solicitar información sobre sus servicios de traducción.",
        },
        footerForm: {
            title: "Contacto rápido",
            name: "Nombre",
            email: "Email",
            message: "Mensaje",
            submit: "Enviar mensaje",
            submitting: "Enviando...",
            success: "Mensaje enviado correctamente.",
            error: "Error al enviar. Inténtalo de nuevo.",
        },
        fileValidation: {
            tooLarge: "El archivo supera el límite de 10 MB. Por favor, selecciona un archivo más pequeño.",
            maxSize: "Tamaño máximo: 10 MB",
        },
        chatbot: {
            title: "Asistente Virtual",
            placeholder: "Escribe tu mensaje...",
            welcome: "¡Hola! Soy el asistente virtual de NM Global Translations. ¿En qué puedo ayudarte?",
            send: "Enviar",
        },
        rgpd: {
            communications: "Acepto recibir comunicaciones comerciales.",
            privacy: "He leído y acepto la política de privacidad.",
        },
    },
    en: {
        topbar: {
            email: "coordination@nmglobaltranslations.com",
            phone1: "+34 618 278 394",
            phone2: "+34 910 600 973",
        },
        nav: {
            languages: "Languages",
            services: "Services",
            quote: "Quote",
            about: "About Us",
            payment: "Payment",
            contact: "Contact",
        },
        hero: {
            title: "Break Language Barriers. Expand Your Business Globally.",
            subtitle: "Professional and sworn translations in over 150 languages.",
            check1: "Certified translators",
            check2: "Fast delivery",
            check3: "Total confidentiality",
            cta: "Request a quote",
        },
        quote: {
            title: "Request a Quote",
            subtitle: "Fill out the form and we will send you a personalized quote within 24-48 hours.",
            sourceLanguage: "Source language",
            targetLanguage: "Target language",
            serviceType: "Service type",
            sworn: "Sworn translation (legally valid)",
            simple: "Simple translation",
            interpretation: "Interpretation",
            deadline: "Desired delivery date",
            selectDate: "Select date",
            uploadFile: "Upload file",
            noFile: "No file selected",
            dragDrop: "Drag your file here or click to select",
            email: "Contact email",
            phone: "Contact phone",
            phonePlaceholder: "Ex: +34 600 000 000",
            message: "Message",
            messagePlaceholder: "Briefly describe your translation project...",
            submit: "Calculate quote",
            submitting: "Submitting...",
            success: "Your request has been submitted successfully. We will contact you soon.",
            error: "Error submitting. Please try again.",
        },
        languages: {
            title: "150+ Languages",
            subtitle: "Professional translations in the world's most demanded languages.",
            search: "Search language...",
        },
        companies: {
            title: "Companies That Trust Us",
            subtitle: "Leading organizations trust our professional translation services.",
        },
        services: {
            title: "Our Services",
            subtitle: "Complete translation solutions for all your needs.",
            simple: {
                title: "Simple Translation",
                description: "Professional translations for all types of documents and content.",
                items: [
                    "Legal translations",
                    "Financial and economic",
                    "Corporate",
                    "Websites and applications",
                    "Technical and IT",
                    "Tourism and advertising",
                    "Medical and pharmaceutical",
                    "Chemical and scientific",
                    "Cultural and literary",
                    "Real estate and construction",
                    "Food and catering",
                    "Telecommunications",
                    "Education and institutional",
                    "Books and newspapers",
                    "Fashion and textiles",
                    "Subtitling and dubbing",
                    "General translations",
                ],
            },
            sworn: {
                title: "Sworn Translation",
                description: "Legally valid translations performed by official sworn translators.",
                includes: "Includes:",
                items: [
                    "Official documents",
                    "Birth certificates",
                    "Marriage certificates",
                    "Divorce certificates",
                    "Credential validations",
                    "Academic documents",
                ],
                features: [
                    "Sworn translator signature",
                    "Official seal",
                    "Full legal validity",
                ],
            },
            interpretation: {
                title: "Interpretation",
                description: "Professional real-time interpretation services.",
                items: [
                    "Simultaneous interpretation",
                    "Consecutive interpretation",
                    "Liaison interpretation",
                    "Whisper interpretation (chuchotage)",
                    "Booth and interpreter equipment rental",
                    "Business meetings",
                    "International events",
                    "Conferences and congresses",
                ],
            },
        },
        aboutCompany: {
            title: "Who we are",
            text: "We are a leading company in translation and interpretation services, with over 20 years of consolidated experience in the sector. Throughout our history, we have worked with a wide variety of specialties, ranging from technical and legal translations to interpretation services in different professional fields, including sworn translations with full legal validity. Our commitment to excellence and linguistic precision has allowed us to achieve an average satisfaction rating of 9.8 out of 10 from our clients, reflecting the trust they place in our team and the consistent quality of our services. We have highly qualified and specialized professionals, capable of adapting to the specific needs of each project, always guaranteeing rigor, confidentiality, and deadline compliance. Choosing us means betting on communication without barriers, backed by experience, professionalism, and a clear client orientation.",
        },
        map: {
            title: "Global Reach",
            subtitle: "Presence on 5 continents. Translations without borders.",
            regions: [
                "Europe",
                "Asia",
                "America",
                "Africa",
                "Oceania",
            ],
        },
        testimonials: {
            title: "NM Global Translations in numbers",
            subtitle: "Thousands of businesses and professionals trust us.",
            metrics: {
                translations: "+20,000",
                translationsLabel: "Translations completed",
                clients: "+1,000",
                clientsLabel: "Satisfied clients",
                satisfaction: "98%",
                satisfactionLabel: "Satisfaction rate",
                delivery: "24-48h",
                deliveryLabel: "Quote turnaround time",
            },
        },
        about: {
            title: "About Us",
            subtitle: "Since 2004, connecting cultures and businesses through quality translations.",
            description: "NM GLOBAL TRANSLATIONS is a global translation agency with over 1,500 professional translators specialized in more than 150 languages.",
            values: [
                { title: "Quality & Specialization", desc: "Native translators specialized in each sector." },
                { title: "Agility & Responsiveness", desc: "Fast delivery without compromising quality." },
                { title: "Adaptability & Multilingual Support", desc: "We adapt to each client's needs." },
                { title: "Confidentiality & Data Security", desc: "Strict information protection protocols." },
                { title: "Deadline Compliance", desc: "We always deliver within the agreed timeframe." },
                { title: "Personalized Attention", desc: "A dedicated manager for each project." },
                { title: "Continuous Improvement & Innovation", desc: "We incorporate the latest translation technologies." },
            ],
        },
        payment: {
            title: "Payment Methods",
            subtitle: "We accept the following payment methods for your convenience.",
            methods: [
                { title: "Bank transfer", desc: "Make your payment via direct bank transfer." },
                { title: "PayPal", desc: "Pay quickly and securely with your PayPal account." },
            ],
        },
        footer: {
            tagline: "Connecting cultures and businesses through high-quality professional translations since 2004",
            quickLinks: "Quick Links",
            contact: "Contact",
            followUs: "Follow Us",
            rights: "All rights reserved.",
            copyright: "NM Global Translations",
            address: "Madrid, Spain",
        },
        whatsapp: {
            tooltip: "Need help? Write us on WhatsApp and we'll reply instantly.",
            openChat: "Open chat",
            defaultMessage: "Hello, I would like to request information about your translation services.",
        },
        footerForm: {
            title: "Quick Contact",
            name: "Name",
            email: "Email",
            message: "Message",
            submit: "Send message",
            submitting: "Sending...",
            success: "Message sent successfully.",
            error: "Error sending. Please try again.",
        },
        fileValidation: {
            tooLarge: "The file exceeds the 10 MB limit. Please select a smaller file.",
            maxSize: "Maximum size: 10 MB",
        },
        chatbot: {
            title: "Virtual Assistant",
            placeholder: "Type your message...",
            welcome: "Hello! I'm NM Global Translations' virtual assistant. How can I help you?",
            send: "Send",
        },
        rgpd: {
            communications: "I agree to receive commercial communications.",
            privacy: "I have read and accept the privacy policy.",
        },
    },
};
